import React from "react";
import { Link } from 'react-router-dom';
import { NavLink } from "react-router-dom";


//Import Css
import './mainMenuBar.css'


export default function MainMenuBar() { 

    return(
     
        <nav className="main-menu-container">
            <NavLink 
                to="/quienes-somos" 
                className={({ isActive }) => 
                isActive 
                    ? "menu-bar-home menu-bar-quienes-somos active" 
                    : "menu-bar-home menu-bar-quienes-somos"
                }
            >
                QUIENES SOMOS
            </NavLink>

            <NavLink 
                to="/soluciones" 
                className={({ isActive }) => 
                isActive 
                    ? "menu-bar-home menu-bar-soluciones active" 
                    : "menu-bar-home menu-bar-soluciones"
                }
            >
                SOLUCIONES
            </NavLink>

            <NavLink 
                to="/tecnologia" 
                className={({ isActive }) => 
                isActive 
                    ? "menu-bar-home menu-bar-tecnologia active" 
                    : "menu-bar-home menu-bar-tecnologia"
                }
            >
                TECNOLOGÍA
            </NavLink>

            <NavLink 
                to="/contactanos" 
                className={({ isActive }) => 
                isActive 
                    ? "menu-bar-home menu-bar-contactenos active" 
                    : "menu-bar-home menu-bar-contactenos"
                }
            >
                CONTÁCTENOS
            </NavLink>
        </nav>

    );
}